import { getSpaceSlugPathQueryOptions, queryClient } from '@onesource/services';
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy post URL. Redirects to `/community-hub/{program}/{feed}/posts/{postId}`.
 * (`$id` is the post's feed sub-space.) Notifications + mobile deep-links still
 * point here, so this redirect keeps them working.
 */
export const Route = createFileRoute('/_protected/community-hub/spaces/$id/posts/$postId')({
  beforeLoad: async ({ params }) => {
    const path = await queryClient.ensureQueryData(getSpaceSlugPathQueryOptions(params.id));
    if (!path.moduleSlug) {
      // Post's space isn't a sub-space (shouldn't happen) — fall back to the program.
      throw redirect({ to: '/programs/$programSlug', params: { programSlug: path.programSlug }, replace: true });
    }
    throw redirect({
      to: '/community-hub/$programSlug/$feedSlug/posts/$postId',
      params: { programSlug: path.programSlug, feedSlug: path.moduleSlug, postId: params.postId },
      replace: true,
    });
  },
});
